<template>
  <div v-if="tags" class="d-flex flex-row">
    <i-badge
      v-for="tag in tags.slice(0, 4)"
      :key="tag.id"
      class="document-tag"
      :colour="iBadgeColours.NEUTRAL"
      :outline="true"
      icon="small-delete-1"
      :has-trailing-icon="showRemoveButton"
      :interactable="showRemoveButton"
      :label="tag.value"
      @right-icon-click="removeTag(tag)"
      @click.stop
    ></i-badge>

    <div v-if="tags.length > 4" class="other-tags">
      <div
        :id="`other-tags-${componentId}`"
        class="i-pill i-text-subheading-3 tag"
      >
        <span class="outline"
          ><i-icon symbol="medium-bookmark-tag" :size="12"></i-icon
        ></span>
      </div>
      <i-tooltip
        :title="
          'Other tags: ' +
          tags
            .slice(4)
            .map((t) => t.value)
            .join(', ')
        "
        :target="`#other-tags-${componentId}`"
        :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
      />
    </div>
  </div>
</template>

<script>
import {
  iBadge,
  iBadgeColours,
  iIcon,
  iTooltip,
  iTooltipAlignmentMode,
  showToast,
} from '@inscribe/signal';

export default {
  components: { iBadge, iIcon, iTooltip },
  props: {
    document: {
      type: Object,
      default: null,
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovering: false,
      iBadgeColours,
      iTooltipAlignmentMode,
      tags: [],
      componentId: crypto.randomUUID(),
    };
  },
  watch: {
    'document.tags': {
      deep: true,
      immediate: true,
      handler: function () {
        this.tags = this.document.tags;
      },
    },
  },
  mounted() {
    this.tags = this.document?.tags || [];
  },
  methods: {
    removeTag(tag) {
      const tagIdx = this.tags.findIndex((currTag) => currTag.id === tag.id);
      if (tagIdx > -1) {
        this.tags.splice(tagIdx, 1);
        this.$store
          .dispatch('deleteDocumentTag', {
            document: this.document,
            tagId: tag.id,
          })
          .then(
            () => {
              showToast({
                text: 'Tag successfully removed.',
              });
            },
            (error) => {
              this.tags.splice(tagIdx, 0, tag);
              showToast({
                text: error?.response,
                isError: true,
              });
            },
          );
      }
    },
  },
};
</script>

<style lang="scss">
.document-tags {
  .dropdown-toggle {
    height: unset;
  }

  .other-tags {
    height: 22px;
    margin-right: 6px;

    .outline {
      height: 22px;
    }
  }

  .document-tag {
    max-width: 200px;
    margin-right: 6px;
  }
}
</style>
